export default "__VITE_ASSET__U0ipv7lm__"